import { EventHandler, Browser, isNullOrUndefined } from '@syncfusion/ej2-base';
import { debounce } from '@syncfusion/ej2-base';
/**
 * InterSectionObserver - class watch whether it enters the viewport.
 *
 * @hidden
 */
var InterSectionObserver = /** @class */ (function () {
    function InterSectionObserver(element, options, movableEle) {
        var _this = this;
        this.fromWheel = false;
        this.touchMove = false;
        this.options = {};
        this.sentinelInfo = {
            'up': {
                check: function (rect, info) {
                    var top = rect.top - _this.containerRect.top;
                    var bottom = _this.containerRect.bottom > rect.bottom ? _this.containerRect.bottom - rect.bottom : 0;
                    info.entered = top >= 0;
                    return top + (_this.options.pageHeight / 2) >= 0 || (bottom > 0 && rect.bottom > 0);
                },
                axis: 'Y'
            },
            'down': {
                check: function (rect, info) {
                    var bottom = rect.bottom;
                    info.entered = rect.bottom <= _this.containerRect.bottom;
                    return ((bottom - _this.containerRect.top) - (_this.options.pageHeight / 2)) <= _this.options.pageHeight / 2;
                }, axis: 'Y'
            },
            'right': {
                check: function (rect, info) {
                    var right = rect.right;
                    info.entered = right < _this.containerRect.right;
                    return right - _this.containerRect.width <= _this.containerRect.right;
                }, axis: 'X'
            },
            'left': {
                check: function (rect, info) {
                    var left = rect.left;
                    info.entered = left > 0;
                    return left + _this.containerRect.width >= _this.containerRect.left;
                }, axis: 'X'
            }
        };
        this.element = element;
        this.options = options;
        this.movableEle = movableEle;
    }
    InterSectionObserver.prototype.observe = function (callback, onEnterCallback) {
        var _this = this;
        this.containerRect = this.options.container.getBoundingClientRect();
        EventHandler.add(this.options.container, 'wheel', function () { return _this.fromWheel = true; }, this);
        if (!isNullOrUndefined(this.options.horizontalScrollbar)) {
            EventHandler.add(this.options.horizontalScrollbar, 'wheel', function () { return _this.fromWheel = true; }, this);
            EventHandler.add(this.options.horizontalScrollbar, 'scroll', this.onVirtualContentScroll(), this);
        }
        if (!isNullOrUndefined(this.options.verticalScrollbar)) {
            EventHandler.add(this.options.verticalScrollbar, 'wheel', function () { return _this.fromWheel = true; }, this);
            EventHandler.add(this.options.verticalScrollbar, 'scroll', this.onVirtualContentScroll(), this);
        }
        EventHandler.add(this.options.container, 'scroll', this.virtualScrollHandler(callback, onEnterCallback), this);
    };
    InterSectionObserver.prototype.check = function (direction) {
        var info = this.sentinelInfo["" + direction];
        return info.check(this.element.getBoundingClientRect(), info);
    };
    InterSectionObserver.prototype.onVirtualContentScroll = function () {
        var _this = this;
        return function (e) {
            if (e.target.classList.contains('e-virtual-vertical-scrollbar')) {
                _this.options.container.scrollTop = e.target.scrollTop;
            }
            if (e.target.classList.contains('e-virtual-horizontal-scrollbar')) {
                _this.options.container.scrollLeft = e.target.scrollLeft;
            }
        };
    };
    InterSectionObserver.prototype.virtualScrollHandler = function (callback, onEnterCallback) {
        var _this = this;
        var browserDelay = Browser.info.name === 'chrome' ? 200 : 100;
        var delay = !isNullOrUndefined(this.options.scrollThrottle)
            ? this.options.scrollThrottle : browserDelay;
        var debounced100 = delay > 0 ? debounce(callback, delay) : callback;
        var debounced50 = debounce(callback, 50);
        this.options.prevTop = this.options.prevLeft = 0;
        return function (e) {
            var top = e.target.scrollTop;
            var left = e.target.scrollLeft;
            var direction = _this.options.prevTop < top ? 'down' : 'up';
            direction = _this.options.prevLeft === left ? direction : _this.options.prevLeft < left ? 'right' : 'left';
            _this.options.prevTop = top;
            _this.options.prevLeft = left;
            if (!isNullOrUndefined(_this.options.verticalScrollbar)) {
                _this.options.verticalScrollbar.scrollTop = _this.options.container.scrollTop;
            }
            if (!isNullOrUndefined(_this.options.horizontalScrollbar)) {
                _this.options.horizontalScrollbar.scrollLeft = _this.options.container.scrollLeft;
            }
            var current = _this.sentinelInfo["" + direction];
            if (_this.options.axes.indexOf(current.axis) === -1) {
                return;
            }
            _this.containerRect = _this.options.container.getBoundingClientRect();
            var check = _this.check(direction);
            if (current.entered) {
                onEnterCallback(_this.element, current, direction, { top: top, left: left }, _this.fromWheel, check);
            }
            if (check) {
                var fn = debounced100;
                if (current.axis === 'X') {
                    fn = debounced50;
                }
                fn({ direction: direction, sentinel: current, offset: { top: top, left: left },
                    focusElement: document.activeElement });
            }
            _this.fromWheel = false;
        };
    };
    InterSectionObserver.prototype.setPageHeight = function (value) {
        this.options.pageHeight = value;
    };
    return InterSectionObserver;
}());
export { InterSectionObserver };
